"use client";

import { BookingScheduleDate } from "@/lib/types/schedule-types";
import { format } from "date-fns";
import { DateRange } from "react-day-picker";

const isDateRange = (
  date: Date | Date[] | DateRange | undefined,
): date is DateRange => {
  return date ? "from" in date : false;
};

export const getDisplayedValue = (
  value: Date | Date[] | DateRange | undefined,
  placeholder?: React.ReactNode | string,
  dateFormat: string = "PPP",
) => {
  if (isDateRange(value)) {
    if (!value.from || !value.to) {
      return placeholder || "Select a date range";
    }

    return `${format(value.from as Date, "PPP")} - ${format(
      value.to as Date,
      "PPP",
    )}`;
  }

  if (Array.isArray(value)) {
    if (!value?.length) {
      return placeholder || "Select dates";
    }
    return value.map((d) => format(d, "PPP")).join(", ");
  }

  if (!value) {
    return placeholder || "Select a date";
  }
  return format(value, dateFormat);
};

export const hasValue = (value: Date | Date[] | DateRange | undefined) => {
  if (isDateRange(value)) {
    return value.from || value.to;
  }

  if (Array.isArray(value)) {
    return value.length > 0;
  }

  return !!value;
};

// Helper to check if the value has { y, m, d } shape and convert it to a Date
export const normalizeDateValue = (
  value: Date | BookingScheduleDate | undefined,
): Date => {
  if (
    value &&
    typeof value === "object" &&
    "y" in value &&
    "m" in value &&
    "d" in value
  ) {
    return new Date(value.y, value.m - 1, value.d); // Convert { y, m, d } to Date
  }
  return value as Date; // Return as-is if already a valid date input
};
